import React from "react";

const TableCell = ({ text }) => (
  <td>
    {text}
  </td>
)

export default TableCell;